import { render, staticRenderFns } from "./ProjectsDoing.vue?vue&type=template&id=3f18b33c&scoped=true"
import script from "./ProjectsDoing.vue?vue&type=script&lang=js"
export * from "./ProjectsDoing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f18b33c",
  null
  
)

export default component.exports